import React, { FC, useEffect, useState } from 'react';
import { Button, Modal, Select } from 'antd';
import { AiOutlineClose } from 'react-icons/ai';
import { useTranslation } from 'react-i18next';
import Loader from '../../../../../components/Loader';
import { getCommonCodeLabel } from '../../../../../lib/store';

interface IProps {
  visible: boolean;

  onSubmit: (reasonCode: string) => void;

  onCancel(): void;
}

const AdminRefundConfirmModal: FC<IProps> = ({
                                               visible,
                                               onSubmit,
                                               onCancel,
                                             }) => {
  const { t } = useTranslation();

  const [isLoading, setIsLoading] = useState(false);
  const [reasonCode, setReasonCode] = useState<'01' | '02' | '03' | '04' | string>();

  useEffect(() => {
    setIsLoading(true);
  }, []);


  return (
    <>
      {isLoading ? <Loader /> : null}
      <Modal
        title={t('관리자 환불')}
        visible={visible}
        onCancel={onCancel}
        width={400}
        closeIcon={<AiOutlineClose onClick={onCancel} />}
        footer={[
          <div className="comm-btn__area justify-content-center">
            <Button key="cancel" className="btn-basic gray" onClick={onCancel}>
              {t('common.button.cancel')}
            </Button>

            <Button key="cancel"
                    className="btn-basic pink"
                    onClick={() => {
                      onSubmit(reasonCode!);
                      onCancel();
                    }}
                    disabled={!reasonCode}
            >
              {t('common.button.confirm')}
            </Button>
          </div>,
        ]}
      >
        <div className="comm-bx__between justify-content-center">
          <Select
            className="w-240"
            placeholder={t('환불 사유 선택')}
            value={reasonCode}
            onChange={(value) => setReasonCode(value)}
          >
            {['01', '02', '03', '04'].map((item: string) => {
              return (<Select.Option key={item} value={item}>
                {getCommonCodeLabel('PA0016', item, 'ko')}
              </Select.Option>);
            })}
          </Select>
        </div>

        <div className="text-center">
          관리자 환불 처리시 POS기와 연동되지 않으며, <br />
          영수증 등 증빙자료를 출력할 수 없습니다.
        </div>
      </Modal>
    </>
  );
};

export default AdminRefundConfirmModal;
